import React, { PureComponent } from 'react';

import { DatePicker } from 'components/date';
import PropTypes from 'prop-types';

import './AccessSelectDatePickers.scss';

const dates = {
  beginDate: 'beginDate',
  endDate: 'endDate'
};

class AccessSelectDatePickers extends PureComponent {
  static propTypes = {
    beginDate: PropTypes.number,
    endDate: PropTypes.number,
    onDateChange: PropTypes.func,
    isDateDisabled: PropTypes.bool
  };

  render() {
    const { beginDate, endDate, onDateChange, isDateDisabled } = this.props;

    return (
      <div className="access__select__datepicker">
        <DatePicker
          date={beginDate}
          onDateChange={(event) => onDateChange(event, dates.beginDate)}
          isOutsideRange={() => false}
          disabled={isDateDisabled}
        />
        <DatePicker
          date={endDate}
          onDateChange={(event) => onDateChange(event, dates.endDate)}
          isOutsideRange={() => false}
          disabled={isDateDisabled}
        />
      </div>
    );
  }
}

export default AccessSelectDatePickers;
